/*
  This is a client library for a Simple Realtime In-memory DB (actually just a dict object) written in python
*/

import EventEmitter from 'wolfy87-eventemitter'
import _ from 'lodash'

// const wsStatus = ['CONNECTING', 'OPEN', 'CLOSING', 'CLOSED']

export default class ReactiveDictClient extends EventEmitter {
  constructor (addr, prefix) {
    super()

    var vm = this

    vm.addr = addr
    vm.prefix = prefix || 'db'
    vm.currentState = {}
    console.log('RDC', vm.prefix, 'setup.')
  }

  _tryToConnect () {
    var vm = this
    vm.emit('connecting')
    console.log('RDC', vm.prefix, 'connecting...', vm.addr)

    var ws = new WebSocket(vm.addr)

    vm.isFirst = true

    vm.send = function (msg) {
      try {
        msg['auth'] = vm.authdetail
        ws.send(JSON.stringify(msg))
      } catch (error) {
        console.log('error - vm.send', error)
      }
    }

    vm.close = function () {
      clearTimeout(vm.retry)
      ws.onclose = function () {} // prevent re-trying
      ws.close()
    }

    ws.onopen = function () {
      vm.emit('connected')

      var ls = location.search
      var bypass = ls.substr(ls.indexOf('bypass') + 7, 52)
      var user = localStorage.getItem('user') || '{ "auth": "Og==" }'
      var authdetail = bypass || JSON.parse(user).auth
      vm.authdetail = authdetail

      console.log('RDC', vm.prefix, 'connected!')
      ws.send(JSON.stringify({'action': 'start', 'auth': authdetail}))
      // ws.send(JSON.stringify({'action': 'start'}))
    }

    ws.onmessage = function (evt) {
      // console.log('RDC', evt.data)
      if (evt.data === 'NO_AUTH') {
        console.log('RDC', 'NO AUTHENTICATION')
        location.href = '/'
        return
      }

      var dataJSON = JSON.parse(evt.data)

      var isSnapshot = !!dataJSON.isSnapshot

      if (isSnapshot) console.log('RDC.isSnapshot', dataJSON)
      if (!isSnapshot) console.log('RDC.!isSnapshot', dataJSON)

      _.each(dataJSON, function (v, k) {
        vm.currentState[k] = v

        vm.emit(k, isSnapshot, v)
      })
    }

    ws.onerror = function (evt) {
      vm.emit('disconnected', true)
      // console.log('RDC', vm.prefix, 'WS: ERROR')
    }

    ws.onclose = function (evt) {
      vm.emit('disconnected', false)
      // console.log('RDC', vm.prefix, 'WS:', wsStatus[ws.readyState])
      vm.retry = setTimeout(function () { vm._tryToConnect() }, 2000) // setTimeout calls function using global 'this' so, _tryToConnect can't use class'es this.``
    }
  }

  connect () { this._tryToConnect() }

  // hello () {
  //   return 'Hello ' + this.name + '!'
  // }

  // static sayHelloAll () {
  //   return 'Hello everyone!'
  // }
}
/*
export class HelloWorld extends Hello2 {
  constructor() {
    super('World');
  }

  echo() {
    alert(super.hello());
  }
}
*/



// WEBPACK FOOTER //
// ./src/ReactiveDictClient.js